"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));

var StyledStepBadge = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  font-size: 0.875rem;\n  color: ", ";\n  background: ", ";\n"])), function (props) {
  return props.isActive ? props.theme.colorAccentText : props.theme.colorLabel;
}, function (props) {
  return props.isActive ? props.theme.colorAccent : props.theme.colorLightGrey;
});

var sharedLineStyles = (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  width: 50%;\n  height: 3px;\n  background: ", ";\n"])), function (p) {
  return p.theme.colorLightGrey;
});

var StyledStep = _styledComponents.default.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 0;\n  position: relative;\n  width: 25%;\n  text-align: center;\n\n  &::before {\n    ", ";\n    left: 0;\n    ", ";\n  }\n\n  &::after {\n    ", ";\n    left: 50%;\n    ", ";\n  }\n\n  &:first-child::before,\n  &:last-child::after {\n    display: none;\n  }\n"])), sharedLineStyles, function (props) {
  return props.isActive && "background: ".concat(props.theme.colorAccent);
}, sharedLineStyles, function (p) {
  return p.isActive && !p.isCurrentStep && "background:".concat(p.theme.colorAccent);
});

var Stepper = function Stepper(_ref) {
  var steps = _ref.steps,
      activeStep = _ref.activeStep,
      onStepClicked = _ref.onStepClicked;

  var isActive = function isActive(step) {
    return step <= activeStep;
  };

  var isCurrentStep = function isCurrentStep(step) {
    return step === activeStep;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    children: steps.map(function (step, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledStep, {
        disabled: !step.isValid,
        onClick: function onClick() {
          return onStepClicked(index);
        },
        isCurrentStep: isCurrentStep(index),
        isActive: isActive(index),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledStepBadge, {
          isActive: isActive(index),
          children: index + 1
        })
      });
    })
  });
};

Stepper.propTypes = {
  activeStep: _propTypes.default.number
};
var _default = Stepper;
exports.default = _default;